/**
 * usePdfUrl — F-007 Phase 4 (IMPL-P4-004).
 *
 * Recupera la presigned URL del PDF originale di una pratica per renderlo in
 * `<iframe>`. La URL ha TTL 60s lato server (cfr. INTRODUCTION.md
 * §"Architectural Decisions"); il client la rinfresca poco prima della
 * scadenza usando `staleTime: 50_000` + `gcTime: 65_000`.
 *
 * `enabled` è false quando `praticaId` è undefined (es. detail page non ancora
 * navigata) per evitare fetch a vuoto.
 */
import { useQuery } from '@tanstack/react-query';
import { operatorClient } from '../lib/operator-client';

export function usePdfUrl(praticaId: string | undefined) {
  return useQuery({
    queryKey: ['operator', 'pdf-url', praticaId] as const,
    queryFn: () => operatorClient.getPdfUrl(praticaId as string),
    enabled: Boolean(praticaId),
    staleTime: 50_000,
    gcTime: 65_000,
  });
}
